// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__15hfU","content":"Consent_content__VKTq9","footer":"Consent_footer__2leZM"};